export const LISTING_TYPE_HUMAN_NAME_MAP = {
  JOB: getText('job'),
  INTERNSHIP: getText('internship'),
  VOLOP: getText('volunteer opportunity'),
  EVENT: getText('event'),
  ORG: getText('organization'),
  GRAD_PROGRAM: getText('graduate program'),
  USER: getText('user'),
  CANDIDATE: getText('candidate'),
};

// For tracking sharing listing events
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getListingTypeHumanName = (listing: any) =>
  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  LISTING_TYPE_HUMAN_NAME_MAP[listing.type];
